export default "__VITE_ASSET__CbNI1FAU__"